
export const delayArray = ['On time', '5 minutes', '10 minutes', '15 minutes', '20 minutes', '30 minutes', '40 minutes', '50 minutes', '1 hour', '2 hours', '3 hours', '4 hours', '5 hours', '6 hours', '7 hours', '8 hours', '9 hours']

